const labOrdenDigitalInitialState = {
  labOrdenDigital: {
    loading: false,
    error: null,
    data: null,
    altaTurno: null,
    load: false,
    pdf: null,
    flgVolver: false
  },
};

export default labOrdenDigitalInitialState;
